// custom tracking for Real User Metrics aka New Relic
// docs here: https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/add-page-action
export function addPageAction(pageAction, payload) {
    let newrelic;
    try {
        newrelic = window.newrelic;
    } catch (e) {
        /*silent */
    }
    if (typeof newrelic === 'object') {
        newrelic.addPageAction(pageAction, payload);
    }
}
